import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { IonButton, IonCard, IonCardTitle, IonCol, IonContent, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonRow, IonText } from "@ionic/react";
import { checkmarkCircleOutline, closeCircleOutline } from "ionicons/icons";

import { GetABMMenu } from "../../store/ABMMenu/ABMMenuActions";
import { GetKpiGroupsMenu } from "../../store/mainInfo/mainInfoActions";

import ToggleABMMenu from "./ToggleABMMenu";
import ApiRequestor from "../../api_access/ApiRequestor";
import { Data } from "./ABMMenuTable";
import Modal from "../Modal/Modal";

import "./ABMMenu.css";

interface Props extends StateTypes, dispatchTypes {
    dataToModify: Data;
    backToTable: () => void;
}

const ModifyABMMenu: React.FC<Props> = (props) => {

    const [showModal, setShowModal] = useState(false);
    const [textModal, setTextModal] = useState('')
    const [menuInfoName, setMenuInfoName] = useState<string>("");
    const [menuInfoTitle, setMenuInfoTitle] = useState<string>("");
    const [menuInfoUrl, setMenuInfoUrl] = useState<string>("");
    const [menuInfoCategory, setMenuInfoCategory] = useState<string[]>([]);
    const [errors, setErrors] = useState({ name: '', title: '', url: '', category: '' });
    const nameRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\/]+(\s[a-zA-ZáéíóúÁÉÍÓÚñÑ\/]+)*$/;
    const regularExpressionURL = /^(?!\/)(?!.*\/\/)([A-Za-z]+(\/[A-Za-z]+)*)$/;

    useEffect(() => {
        if (props.dataToModify) {
            setMenuInfoName(props.dataToModify.menuinfo_name);
            setMenuInfoTitle(props.dataToModify.menuinfo_title);
            setMenuInfoUrl(props.dataToModify.menuinfo_url.replace("/page/", ""));
            setMenuInfoCategory(props.dataToModify.menuinfo_category);
        }
    }, [props.dataToModify]);

    const validationForm = () => {
        const isEmpty = (value: any) => {
            if (Array.isArray(value)) return value.length === 0 || value.every(item => item.trim() === "");
            if (typeof value === "string") return value.trim() === "";
            return !value;
        };
        const isInvalidText = (value: any) => !nameRegex.test(value);
        const isInvalidURL = (value: any) => !regularExpressionURL.test(value);

        const errors = {
            name: isEmpty(menuInfoName)
                ? 'Se debe seleccionar un ícono.'
                : '',
            title: isEmpty(menuInfoTitle)
                ? 'El campo no debe estar vacío.'
                : isInvalidText(menuInfoTitle) || menuInfoTitle.length >= 30
                    ? 'Solo letras y espacios intermedios. Máximo 30 carácteres.'
                    : '',
            url: isEmpty(menuInfoUrl)
                ? 'El campo no debe estar vacío.'
                : isInvalidURL(menuInfoUrl) || menuInfoUrl.length >= 30
                    ? 'Solo letras y /. Máximo 30 carácteres.'
                    : '',
            category: isEmpty(menuInfoCategory)
                ? 'Se debe seleccionar por lo menos una categoría.'
                : ''
        };

        setErrors(errors as any);
        const hasErrors = Object.values(errors).some(error => error !== '');

        return hasErrors;
    }

    const handleModify = async (e: any) => {

        e.preventDefault();
        validationForm();

        let valid = validationForm();

        if (!valid) {

            let data: any = {
                params: [props.dataToModify.menuinfo_id],
                body: {
                    "menuinfo_name": menuInfoName,
                    "menuinfo_title": menuInfoTitle,
                    "menuinfo_url": `/page/${menuInfoUrl}`,
                    "menuinfo_category": menuInfoCategory,
                }
            };

            const response = await ApiRequestor.requestToApi("/swt-admin/menu-info", "PUT", data, "DATA");

            if (response?.status === 200) {
                setTextModal('Item Menú Modificado Correctamente')
                props.getABMMenu();
                props.getMenuInfo();
                setShowModal(true);
            } else {
                console.error(response);
                setTextModal('No se pudo crear el usuario. Por favor chequear los datos ingresados')
                setShowModal(true)
            }
        } else {
            validationForm()
        }
    };

    const dismissModal = () => {
        props.backToTable()
    }

    return (
        <div className="custom-content-scroll">
            <IonCard className="abmmenu-card-add">
                <IonCardTitle className="abmmenu-title-add">MODIFICAR ÍTEM DE MENÚ</IonCardTitle>
                <IonGrid className="abmmenu-grid-add">
                    <IonRow>
                        <IonCol sizeXl="6" sizeXs="12">
                            <IonLabel className="abmmenu-label-add">Título</IonLabel>
                            <IonItem className="abmmenu-item-add" lines="none">
                                <IonInput
                                    value={menuInfoTitle}
                                    placeholder="Ingrese el título"
                                    onIonChange={(e) => setMenuInfoTitle(e.detail.value!)}
                                />
                            </IonItem>
                            <IonText>
                                <p className={errors.title ? "abmmenu-valid-text" : "ion-hide"}>{errors.title}</p>
                            </IonText>
                        </IonCol>

                        <IonCol sizeXl="6" sizeXs="12">
                            <IonLabel className="abmmenu-label-add">URL</IonLabel>
                            <IonItem className="abmmenu-item-add" lines="none">
                                <IonLabel>/page/</IonLabel>
                                <IonInput
                                    value={menuInfoUrl}
                                    placeholder="Ingrese el URL"
                                    onIonChange={(e) => setMenuInfoUrl(e.detail.value!)}
                                />
                            </IonItem>
                            <IonText>
                                <p className={errors.url ? "abmmenu-valid-text" : "ion-hide"}>{errors.url}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        <IonCol size="12">
                            <IonLabel className="abmmenu-label-add">Categoría</IonLabel>
                            <ToggleABMMenu
                                options={'categoria'}
                                onSelectionChange={(selected) => setMenuInfoCategory(selected)}
                                initialSelected={menuInfoCategory}
                            />
                            <IonText>
                                <p className={errors.category ? "abmmenu-valid-text" : "ion-hide"}>{errors.category}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        <IonCol size="12" >
                            <IonLabel className="abmmenu-label-add">Ícono</IonLabel>
                                <ToggleABMMenu
                                    onIconSelect={(iconName) => setMenuInfoName(iconName)}
                                    initialSelectedIcon={menuInfoName}
                                />
                        </IonCol>
                        <IonText>
                            <p className={errors.name ? "abmmenu-valid-text" : "ion-hide"}>{errors.name}</p>
                        </IonText>
                    </IonRow>

                    <IonRow className="abmmenu-boton-container">
                        <IonButton fill="clear" onClick={handleModify}>
                            <IonIcon icon={checkmarkCircleOutline} color="success" className=" abmmenu-boton-icon" />
                        </IonButton>

                        <IonButton fill="clear" onClick={props.backToTable}>
                            <IonIcon icon={closeCircleOutline} color="danger" className=" abmmenu-boton-icon" />
                        </IonButton>
                    </IonRow>
                </IonGrid>
            </IonCard>

            <Modal
                modalConfirmation={{
                    textConfirmation: textModal,
                    onDidDimissConfirmModal: dismissModal,
                    isOpenModalConfirm: showModal,
                    onClickConfirmModal: dismissModal,
                }}
            />
        </div>
    );
};
interface StateTypes {

}

const mapStatetoProps = (state: StateTypes) => ({

});

interface dispatchTypes {
    getABMMenu: () => void;
    getMenuInfo: () => void
}
const mapDispatchToProps = (dispatch: any) => ({
    getABMMenu: () => dispatch(GetABMMenu()),
    getMenuInfo: () => dispatch(GetKpiGroupsMenu()),
});

export default connect(mapStatetoProps, mapDispatchToProps)(ModifyABMMenu);
